<template>
  <div class="Page">
    <div v-if="this.current">
      <!--Banner-->
      <section class="" v-if="this.dealerSelected">
          <div class="banner" :style="this.dealerSelected.detailed.banner ? { backgroundImage: 'url(' + this.dealerSelected.detailed.banner + ')' } : {}">
              <h1 class="PageTitle">Postuler en ligne</h1>
          </div>
          <div class="orangeStripe"></div>
      </section>
      <section v-else>
          <div class="banner">
              <h1 class="PageTitle">Postuler en ligne</h1>
          </div>
          <div class="orangeStripe"></div>
      </section>
      <section>
          <form ref="formApply" role="form" method="POST" action="https://reseaudynamique.com/ressources/api/emails.php" enctype="multipart/form-data" @submit.prevent="validateAndSubmit"> <!-- method="POST" action="/<?php echo $NOMPAGE; ?>" -->
              <input type="hidden" id="emailId" name="emailId" value="4">
              <input type="hidden" id="jobId" name="jobId" :value="this.$route.params.emp">
              <v-row id="fourthBloc" class=" BGBloc4">
                  <v-col cols="12"><h2 class="FormTitle">{{this.current.title}} </h2></v-col>
                  <v-col cols="12"><p class="electrikText">Formulaire pour postuler</p></v-col> 
                  <v-row class="grid boxForm form">
                      <v-col cols="12" md="6" class="inputForm"> 
                          <input name="nomComplet" id="nomComplet" type="text" placeholder="Nom complet" class=""  v-model="form.prenom" required>  
                      </v-col>                        
                      <v-col cols="12" md="6" class="inputForm"> 
                          <input name="work" id="work" type="text" placeholder="Travail" class="" v-model="form.work" required> 
                      </v-col>
                      <v-col cols="12" md="6" class="inputForm"> 
                          <input name="town" id="town" type="text" placeholder="Votre ville" class="" v-model="form.town" required> 
                      </v-col>
                      <v-col cols="12" md="6" class="inputForm"> 
                          <input name="email" id="email" type="email" placeholder="Courriel" class="" v-model="form.email" required>
                          <p v-if="errors.email" class="errorMsg">{{ errors.email }}</p> 
                      </v-col>
                      <v-col cols="12" md="6" class="inputForm"> 
                          <input name="telephone" id="telephone" type="tel" placeholder="(514) 555-1234" class="" v-model="form.telephone" @input="formatTelephone" required>
                          <p v-if="errors.telephone" class="errorMsg">{{ errors.telephone }}</p> 
                      </v-col>
                      <v-col cols="12" md="6" class="inputForm"> 
                          <input name="compagnie" id="compagnie" type="text" placeholder="Succursale" class="" v-model="form.compagnie" required> 
                      </v-col>
                      <v-col cols="12" md="12" class="inputForm">
                          <textarea name="comment" id="comment" placeholder="Quelques mots sur vous" v-model="form.comment" style="width:95%; min-height:100px;" required></textarea>
                      </v-col>
                      <v-col cols="12" md="12" class="inputForm">
                        <label for="cv" class="cvText">Votre CV (PDF ou JPG)</label>
                        <input style="width: 95%;" type="file" name="cv" id="cv" accept=".pdf,.jpg" required>
                      </v-col>
                      <!--
                      <v-col cols="12" md="12" class="inputForm">
                        <a style="color: #FFF; font-family: TxtOffBDI; font" @click="this.sendingForm();">Soumettre</a>
                      </v-col>-->
                  </v-row>
                  <button  name="btnSendMail" id="btnSendMail" type="submit" value="Envoyer" ><a>Soumettre</a></button>
                  <h2 v-if="sendForm == true" class="electrikText">Votre demande a bien été envoyée</h2>
              </v-row>
          </form>
        </section>
    </div>
    <div  v-if="!this.current">
        <v-row class="titleBg">
            <v-row class="bgCharging">
                <v-col><h1 class="titleCharging txt-c">La fiche de travail est en chargement <v-progress-circular style="color: rgb(var(--primary));" :size="75" :width="8" indeterminate></v-progress-circular></h1> 
                </v-col>
            </v-row>

        </v-row>
    </div>
  </div>
</template>
<style scoped>
    .v-row { width: 100%; }
    .PageTitle { position: absolute; top: 50%; left: 50%; transform: translate(-50%,-50%); text-align: center; z-index: 100; }
    .banner { position: relative; height: 400px; background-image: url('../../public/ressources/images/sales/banner.jpg'); background-position: center center; background-repeat: no-repeat; background-size: cover; overflow: hidden; }
    .titleCharging { position: absolute; top:50%; left: 50%; transform: translate(-50%,-50%); font-family: TxtOffBDI; color: black; font-size: 36px; text-transform: uppercase;}
    .bgCharging { min-height: 700px; background-image: url('../../public/ressources/images/background-truck.jpg'); background-position: center center; background-size: cover; }
    /*#region info*/
      .containerImg { height: 600px; padding: 0px; overflow: hidden; display: flex; align-items: center; justify-content: center; }
      .containerImg img {  object-fit: cover; object-position: center center; }
      .infoSection { background-color: rgb(var(--ligthGray)); padding: 50px; }
      .infoTitle { color: rgb(var(--secondary)); text-transform: uppercase; font-size: 32px; font-family: TxtOffBDI;  }
      .textSection { margin-top: 50px !important; }
      .textSection p { font-family: TxtOffRe;  font-size: 28px; padding-left: 20px;}
      .textSection a { font-family: TxtOffRe;  font-size: 28px; padding-left: 20px;}
      .textSection img { width: 60px; }
      .infoRow { padding: 5px 0px; }
    /*#endregion*/
    /*#region require*/
      .containerRequireImg { height: 600px; padding: 0px; overflow: hidden; display: flex; align-items: center; justify-content: center; }
      .containerRequireImg img { width: 100%; height: 100%; object-fit: cover; object-position: center center; }
      .requireSection {  background-color: rgb(var(--gray)); padding: 50px !important; position: relative; }
      .requireTitle { color: rgb(var(--secondary)); text-transform: uppercase; font-size: 32px; font-family: TxtOffBDI; margin-bottom: 30px; }
      .requireText { color: rgb(var(--white)); font-family: TxtOffRe;  font-size: 28px; font-weight: 700; padding: 20px 20%; text-align: center; }
      .requireSection p { font-family: TxtOffRe;  color: rgb(var(--white));  font-size: 28px; padding-left: 20px;}
      .requireSection a { font-family: TxtOffRe;  color: rgb(var(--white));  font-size: 28px; padding-left: 20px;}
      .requireSection a:hover { color: rgb(var(--primary)); }
      .requireSection img { width: 30px; margin-left: 20px;}
    /*#endregion*/
    /*#region apply*/
      .applyBG { position: relative; width: 100%; background-color: black; padding: 0px 50px; height: 100%; }
      .applyAlignText { position: relative; top:50%; left: 50%; transform: translate(-50%,-50%);}
      .applyTitle { color: white; font-family: TxtOffBDI; text-transform: uppercase;  }
      .applyText { font-family: TxtOffRe; margin-top: 20px;  }
    /*#endregion*/
    /*Region section form*/
        .FormTitle { text-align: center; color: #fff;}
        .electrikText { text-align: center; color: #fff; padding: 20px 0px; font-size: 24px; font-weight: 100; line-height: normal;}
        .cvText { color: #fff; padding: 20px 0px; font-size: 1rem; font-weight: 100; line-height: normal;}
        .BGBloc4 {position:relative;  height: 100%; padding: 10px 0px 10px 0px; background-image: url('../../public/ressources/images/truckElectrik/bloc3BG.jpg'); background-repeat: no-repeat; background-size: cover; background-position: center center;}
        .boxForm { padding: 0px 350px; }
        .realization { padding: 25px 0px; }
        .form input { color: white; background-color: rgba(17,17,17,1); padding: 10px 20px; height: 50px; border: none; font-weight: 100; font-size: 24px;  width: 90%;}
        .form textarea { color: white; background-color: rgba(17,17,17,1); padding: 10px 20px; height: 50px; border: none; font-weight: 100; font-size: 24px;  width: 90%;}
        .form select { color: white; background-color: rgba(17,17,17,1); padding: 10px 20px; height: 50px; border: none; font-weight: 100; font-size: 24px;  width: 90%;}
        .form .v-text-field input { color: white; background-color: rgba(17,17,17,1) !important; padding: 10px 20px; height: 50px; border: none; font-weight: 100; font-size: 24px;  width: 90%;}
        .form p { color: white; }
        .inputForm { padding: 20px; }
        #ElectrikPage a {text-decoration: none; color:white;}
        #fourthBloc { padding: 100px 0px !important; }
        #fourthBloc button { margin-top:40px; margin-right: auto; margin-left: auto; font-size:24px; display: block; min-width: 200px; padding:20px; background-color: rgb(var(--secondary)); font-weight: 700; text-transform: uppercase; }
        #fourthBloc button a { color: #FFF; font-family: TxtOffBDI; }
        #fourthBloc button:hover {box-shadow: 0px 0px 10px rgb(var(--primary)); cursor: pointer;}
    /*#endregion */    
    /*Region section 3*/
        .electrikText { text-align: center; color: #fff; padding: 20px 0px; font-size: 24px; font-weight: 100; line-height: normal;}
        .BGBloc4 {position:relative;  height: 100%; padding: 10px 0px 10px 0px; background-image: url('../../public/ressources/images/truckElectrik/bloc3BG.jpg'); background-repeat: no-repeat; background-size: cover; background-position: center center;}
        .boxForm { padding: 0px 350px; }
        .realization { padding: 25px 0px; }
        .form input { color: white; background-color: rgba(17,17,17,1); padding: 10px 20px; height: 50px; border: none; font-weight: 100; font-size: 24px;  width: 90%;}
        .form select { color: white; background-color: rgba(17,17,17,1); padding: 10px 20px; height: 50px; border: none; font-weight: 100; font-size: 24px;  width: 90%;}
        .form .v-text-field input { color: white; background-color: rgba(17,17,17,1) !important; padding: 10px 20px; height: 50px; border: none; font-weight: 100; font-size: 24px;  width: 90%;}
        .inputForm { padding: 20px; }
        #ElectrikPage a {text-decoration: none; color:white;}
        #fourthBloc { padding: 100px 0px !important; }
        #fourthBloc button { margin-top:40px; margin-right: auto; margin-left: auto; font-size:24px; display: block; min-width: 200px; padding:20px; background-color: rgb(var(--secondary)); font-weight: 700; text-transform: uppercase; }
        #fourthBloc button a { color: #FFF; font-family: TxtOffBDI; }
        #fourthBloc button:hover {box-shadow: 0px 0px 10px rgb(var(--primary)); cursor: pointer;}
        .errorMsg { color: rgb(var(--primary)); font-size: 14px; font-family: TxtOffRe; margin-top: 5px; padding-left: 0px; }
    /*#endregion */

    @media handheld, only screen and (max-width: 600px) {}
    @media handheld, only screen and (max-width: 960px) {
      h1 { font-size: 18px; }
      h2 { font-size: 18px; }
      .boxForm { padding: 0px 20px !important; }
      .form input { width: 100%; }
      .form select { width: 100%; }
    }
    @media handheld, only screen and (max-width: 1279px) {}
    @media handheld, only screen and (max-width: 1378px) {}
</style>
<script>

export default {
  name: 'job',
  data:()=>({
    current:null,
    errorMessage:null,
    jobsDB:null,
    jobsDbRD:null,
    jobkey:null,
    dealerkey:null,
    dealers:null,
    dealerSelected: null,
    sendForm: null, // send, error, pending
    errors: {
        telephone: '',
        email: '',
    },
    form: {
        work: '',
        nom: '',
        function: '',
        truckChoice: '',
        compagnie: '',
        telephone: '',
        town: '',
        email: '',
        address: '',
        comment: ''
    }
  }),
  async beforeMount(){
    

  },
  async mounted() {
    await this.dealersJsonRead();
    if(this.dealers) { this.dealers = await this.normalizeKeysToLower(this.dealers); }

    let jobkey = this.$route.params.emp;

    if(jobkey && jobkey != 9999 ) { this.readData(jobkey); } else{ this.noJobApply();  }
    
    

  },
  methods:{
    /** Formate le téléphone en (XXX) XXX-XXXX et bloque les non-chiffres */
    formatTelephone: function() {
        let digits = this.form.telephone.replace(/\D/g, '');
        if (digits.length > 10) { digits = digits.substring(0, 10); }
        let formatted = '';
        if (digits.length > 0) { formatted = '(' + digits.substring(0, 3); }
        if (digits.length >= 3) { formatted += ') '; }
        if (digits.length > 3) { formatted += digits.substring(3, 6); }
        if (digits.length >= 6) { formatted += '-'; }
        if (digits.length > 6) { formatted += digits.substring(6, 10); }
        this.form.telephone = formatted;
        this.errors.telephone = '';
    },
    /** Valide le format du courriel */
    validateEmail: function() {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!this.form.email) { this.errors.email = 'Le courriel est requis.'; return false; }
        if (!regex.test(this.form.email)) { this.errors.email = 'Le format du courriel est invalide.'; return false; }
        this.errors.email = '';
        return true;
    },
    /** Valide le téléphone (10 chiffres avec indicatif régional) */
    validateTelephone: function() {
        const digits = this.form.telephone.replace(/\D/g, '');
        if (!digits) { this.errors.telephone = 'Le numéro de téléphone est requis.'; return false; }
        if (digits.length < 10) { this.errors.telephone = 'Le numéro doit contenir 10 chiffres (indicatif régional inclus).'; return false; }
        this.errors.telephone = '';
        return true;
    },
    /** Valide tout le formulaire avant soumission */
    validateAndSubmit: function() {
        const telValid = this.validateTelephone();
        const emailValid = this.validateEmail();
        if (telValid && emailValid) { this.$refs.formApply.submit(); }
    },
    dealersJsonRead: async function () {
        try {
            const response = await fetch('/ressources/json/dealers.json');
            if (!response.ok) {
                throw new Error('Failed to fetch');
            }
            this.dealers = await response.json();
        } catch (error) {
            console.error('Error loading JSON data:', error);
        }
    },
    readData: async function(jobSelected){
      let api = 'https://reseaudynamique.com/ressources/api/jobs.php?id=';
      api = api + jobSelected;
      try {
          const response = await fetch(api);
          if (!response.ok) {
            throw new Error('Failed to fetch');
          }
          this.current = await response.json();
          this.current = this.current[0];
          if(this.current) { this.feedDealer(this.current.branch); this.form.work = this.current.title; }
      } catch (error) {
          console.error('Error loading JSON data:', error);
      }
    },
    noJobApply: function() {
      try{
            let data = {
              "key":"none",
              "title":"Candidature spontanée",
              "banner":"/ressources/images/career/job/applyImg.jpg",
              "dealersKey":null,
              "dealer":[],
              "infoJob":null,
              "schedule":null,
              "startJob":null,
              "salary":null,
              "yearsExperience":null,
              "spokenLanguages":null,
              "writtenLanguages":null,
              "levelStudy":null,
              "otherRequirement":null,
              "Contact":{
                  "contactNom":"ROGER LACHAPELLE",
                  "contactTitre":null,
                  "contactTel":"4507747213",
                  "contactCourriel":"rlachapelle@camionbeaudoin.com"
              }
            }
            let job;
            // compare Api avec parametre dealer (url);
            if(data){
              job = data;      
              this.current = job;
              this.form.work = "Candidature spontanée";
            }

        } catch (error) {
            console.error('Error loading JSON data:', error);
        }
    },
    feedDealer: function(dealer) {
      if(dealer) {
        try {
          dealer = dealer.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
          if(dealer) { this.dealerSelected = this.dealers[dealer]; this.form.compagnie = this.dealerSelected.name;  }
        } 
        catch (error) { this.dealerSelected = {"branch" : this.dealerSelected}; this.errorMessage = "Une erreur c'est produite dans la fiche technique"; }
        
      } else {
        this.dealerSelected = null;
      }
    },
    normalizeKeysToLower: async function(data){
        return Object.fromEntries(
          Object.entries(data).map(([k, v]) => [k.toLowerCase(), v])
        )
    },
    sendingForm: function() {
      let formData = new FormData(this.$refs.form);
      console.log(formData);
    }
  },
  components: { }
}
</script>
